import { createFileRoute } from '@tanstack/react-router';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';
import { MachineCreateSheet } from '@/pages/machines/form/machine-create-sheet';
import { MACHINES_ROUTE } from '@/pages/machines/lib/routes';

export const Route = createFileRoute('/protected/_layout/machines/_layout/new')(
  {
    ...createSheetRouteOptions(MACHINES_ROUTE, { size: 'wide' }),
    component: MachineCreateRoute,
  }
);

function MachineCreateRoute() {
  const { customerId } = Route.useSearch();
  return (
    <MachineCreateSheet returnUrl={MACHINES_ROUTE} customerId={customerId} />
  );
}
